import { analyticsConstants } from '../constants';
import { generalHelpers } from '../helpers';
import { analyticsService } from '../services';
import { Analytics } from '../shared/types';
import { Redux } from '../types';
import { generalErrorHandler } from './utils';

export default {
  flush,
  queue,
};

export type QueueAction = Redux.SimpleAction & {
  action: Analytics.Action;
};

function queue(action: Analytics.Action): QueueAction {
  return {
    type: analyticsConstants.QUEUE,
    action,
  };
}

export type FlushAction = Redux.SimpleAction & {
  actions: readonly Analytics.IdentifiableAction[];
};
type FlushThunkAction = Redux.ThunkAction<FlushAction>;

function flush(
  actions: readonly Analytics.IdentifiableAction[]
): FlushThunkAction {
  return dispatch => {
    return actions.length > 0
      ? analyticsService.flush(actions).then(
          () => {
            dispatch(success(actions));
          },
          generalErrorHandler(dispatch, generalHelpers.noop)
        )
      : Promise.resolve();
  };

  function success(
    actions: readonly Analytics.IdentifiableAction[]
  ): FlushAction {
    return { type: analyticsConstants.FLUSH, actions };
  }
}
